import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../commanstyles.module.css";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";

function Demat_of_shares({ isSubScribe, data }) {
    const navigate = useNavigate();
    const [currentPageEquity, setCurrentPageEquity] = useState(1);
    const [currentPagePreference, setCurrentPagePreference] = useState(1);
    const [isEquityTableOpen, setIsEquityTableOpen] = useState(true);
    const [isPreferenceTableOpen, setIsPreferenceTableOpen] = useState(true);
    const rowsPerPage = 10;

    // Filter data by category (Equity Shares and Preference Shares)
    const equityData = data.filter((row) => row.category === "EQUITY SHARES");
    const preferenceData = data.filter(
        (row) => row.category === "PREFERENCE SHARES"
    );

    // Calculate total pages for both tables
    const totalPagesEquity = Math.ceil(equityData.length / rowsPerPage);
    const totalPagesPreference = Math.ceil(preferenceData.length / rowsPerPage);

    // Pagination handlers for each table
    const handleClickEquity = (page) => setCurrentPageEquity(page);
    const handleClickPreference = (page) => setCurrentPagePreference(page);
    const handlePreviousEquity = () =>
        currentPageEquity > 1 && setCurrentPageEquity(currentPageEquity - 1);
    const handlePreviousPreference = () =>
        currentPagePreference > 1 &&
        setCurrentPagePreference(currentPagePreference - 1);
    const handleNextEquity = () =>
        currentPageEquity < totalPagesEquity &&
        setCurrentPageEquity(currentPageEquity + 1);
    const handleNextPreference = () =>
        currentPagePreference < totalPagesPreference &&
        setCurrentPagePreference(currentPagePreference + 1);

    // Get the data for each page
    const indexOfLastRowEquity = currentPageEquity * rowsPerPage;
    const indexOfFirstRowEquity = indexOfLastRowEquity - rowsPerPage;
    const currentEquityData = equityData.slice(
        indexOfFirstRowEquity,
        indexOfLastRowEquity
    );

    const indexOfLastRowPreference = currentPagePreference * rowsPerPage;
    const indexOfFirstRowPreference = indexOfLastRowPreference - rowsPerPage;
    const currentPreferenceData = preferenceData.slice(
        indexOfFirstRowPreference,
        indexOfLastRowPreference
    );

    // Toggle for each section
    const toggleEquityTable = () => {
        setIsEquityTableOpen(!isEquityTableOpen);
    };

    const togglePreferenceTable = () => {
        setIsPreferenceTableOpen(!isPreferenceTableOpen);
    };

    if (!isSubScribe) {
        return (
            <div className={styles.table_subcontainer}>
                <button className={styles.Subscription_msg} onClick={() => navigate("/kohere/mycredits", { state: { active: "BuyCredits" } })}>
                    <IoMdLock /> Subscription required to view data
                </button>
            </div>
        );
    }

    return (
        <div className={styles.table_subcontainer}>
            {/* EQUITY SHARES Section */}
            <div>
                <div className={styles.highlet_header_content1}>
                    <p
                        className={styles.minuse_icon}
                        onClick={toggleEquityTable}>
                        {isEquityTableOpen ? (
                            <FaMinusSquare size={22} />
                        ) : (
                            <FaPlusSquare size={22} />
                        )}
                    </p>
                    <h3 className={styles.highlet_text}>
                        DEMAT OF EQUITY SHARES
                    </h3>
                </div>

                {isEquityTableOpen && (
                    <>
                        {isSubScribe && (
                            <table className={styles.commantable}>
                                <thead>
                                    <tr className={styles.tableHeaderRow}>
                                        <th className={styles.tableHeader}>
                                            S.No
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Class of Shares
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Physical Shares
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Demat Shares
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Total Equity Shares
                                        </th>
                                        <th className={styles.tableHeader}>
                                            ISIN of the Equity shares
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentEquityData.length > 0 ? (
                                        currentEquityData.map((row, index) => (
                                            <tr
                                                key={row.id}
                                                className={styles.tableRow}>
                                                <td
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    {index + 1}
                                                </td>
                                                <td
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    {row.class_of_shares}
                                                </td>
                                                <td
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    {row.physical_shares}
                                                </td>
                                                <td
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    {row.demat_shares}
                                                </td>
                                                <td
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    {row.total_equity_shares}
                                                </td>
                                                <td
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    {
                                                        row.isin_of_the_equity_shares
                                                    }
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan="6"
                                                className={styles.noData} style={{ textAlign: "center" }}>
                                                No Demat of Shares data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}

                        {/* Pagination controls for EQUITY SHARES */}
                        {isSubScribe && currentEquityData.length > 0 && (
                            <div className={styles.pagination}>
                                <button
                                    onClick={handlePreviousEquity}
                                    disabled={currentPageEquity === 1}>
                                    &lt;
                                </button>
                                {[...Array(totalPagesEquity).keys()].map(
                                    (num) => (
                                        <button
                                            key={num + 1}
                                            onClick={() =>
                                                handleClickEquity(num + 1)
                                            }
                                            className={
                                                currentPageEquity === num + 1
                                                    ? styles.active
                                                    : ""
                                            }>
                                            {num + 1}
                                        </button>
                                    )
                                )}
                                <button
                                    onClick={handleNextEquity}
                                    disabled={
                                        currentPageEquity === totalPagesEquity
                                    }>
                                    &gt;
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>

            {/* PREFERENCE SHARES Section */}
            <div>
                <div className={styles.highlet_header_content1}>
                    <p
                        className={styles.minuse_icon}
                        onClick={togglePreferenceTable}>
                        {isPreferenceTableOpen ? (
                            <FaMinusSquare size={22} />
                        ) : (
                            <FaPlusSquare size={22} />
                        )}
                    </p>
                    <h3 className={styles.highlet_text}>
                        DEMAT OF PREFERENCE SHARES
                    </h3>
                </div>

                {isPreferenceTableOpen && (
                    <>
                        {isSubScribe && (
                            <table className={styles.commantable}>
                                <thead>
                                    <tr className={styles.tableHeaderRow}>
                                        <th className={styles.tableHeader}>
                                            S.No
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Class of Shares
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Physical Shares
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Demat Shares
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Total Preference Shares
                                        </th>
                                        <th className={styles.tableHeader}>
                                            ISIN of Preference Shares
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentPreferenceData.length > 0 ? (
                                        currentPreferenceData.map(
                                            (row, index) => (
                                                <tr
                                                    key={row.id}
                                                    className={styles.tableRow}>
                                                    <td
                                                        className={
                                                            styles.tableCell
                                                        }>
                                                        {index + 1}
                                                    </td>
                                                    <td
                                                        className={
                                                            styles.tableCell
                                                        }>
                                                        {row.class_of_shares}
                                                    </td>
                                                    <td
                                                        className={
                                                            styles.tableCell
                                                        }>
                                                        {row.physical_shares}
                                                    </td>
                                                    <td
                                                        className={
                                                            styles.tableCell
                                                        }>
                                                        {row.demat_shares}
                                                    </td>
                                                    <td
                                                        className={
                                                            styles.tableCell
                                                        }>
                                                        {
                                                            row.total_equity_shares
                                                        }
                                                    </td>
                                                    <td
                                                        className={
                                                            styles.tableCell
                                                        }>
                                                        {
                                                            row.isin_of_the_equity_shares
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        )
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan="6"
                                                className={styles.noData} style={{ textAlign: "center" }}>
                                                No Demat of preference shares data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}

                        {/* Pagination controls for PREFERENCE SHARES */}
                        {isSubScribe && currentPreferenceData.length > 0 && (
                            <div className={styles.pagination}>
                                <button
                                    onClick={handlePreviousPreference}
                                    disabled={currentPagePreference === 1}>
                                    &lt;
                                </button>
                                {[...Array(totalPagesPreference).keys()].map(
                                    (num) => (
                                        <button
                                            key={num + 1}
                                            onClick={() =>
                                                handleClickPreference(num + 1)
                                            }
                                            className={
                                                currentPagePreference ===
                                                    num + 1
                                                    ? styles.active
                                                    : ""
                                            }>
                                            {num + 1}
                                        </button>
                                    )
                                )}
                                <button
                                    onClick={handleNextPreference}
                                    disabled={
                                        currentPagePreference ===
                                        totalPagesPreference
                                    }>
                                    &gt;
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

export default Demat_of_shares;
